export enum ProjectSectionUnitStatus {
  NOT_STARTED = 'NOT_STARTED',
  STARTED = 'STARTED',
  COMPLETED = 'COMPLETED',
  SELF_PASS = 'SELF_PASS',
  SUPERVISE_PASS = 'SUPERVISE_PASS',
  JG_PASS = 'JG_PASS',
  NOT_PASS = 'NOT_PASS',
}

export const ProjectSectionUnitStatusMap = {
  [ProjectSectionUnitStatus.NOT_STARTED]: '未开工',
  [ProjectSectionUnitStatus.STARTED]: '已开工',
  [ProjectSectionUnitStatus.COMPLETED]: '已完工',
  [ProjectSectionUnitStatus.SELF_PASS]: '自检合格',
  [ProjectSectionUnitStatus.SUPERVISE_PASS]: '监理合格',
  [ProjectSectionUnitStatus.JG_PASS]: '交工合格',
  [ProjectSectionUnitStatus.NOT_PASS]: '不合格',
};

export const ProjectSectionUnitStatusColorMap = {
  [ProjectSectionUnitStatus.NOT_STARTED]: '',
  [ProjectSectionUnitStatus.STARTED]: 'color-primary',
  [ProjectSectionUnitStatus.COMPLETED]: 'color-light',
  [ProjectSectionUnitStatus.SELF_PASS]: 'color-success',
  [ProjectSectionUnitStatus.SUPERVISE_PASS]: 'color-success',
  [ProjectSectionUnitStatus.JG_PASS]: 'color-success',
  [ProjectSectionUnitStatus.NOT_PASS]: 'color-danger',
};

export const ProjectSectionUnitStatusList = [
  {
    value: ProjectSectionUnitStatus.NOT_STARTED,
    label: ProjectSectionUnitStatusMap[ProjectSectionUnitStatus.NOT_STARTED],
  },
  {
    value: ProjectSectionUnitStatus.STARTED,
    label: ProjectSectionUnitStatusMap[ProjectSectionUnitStatus.STARTED],
  },
  {
    value: ProjectSectionUnitStatus.COMPLETED,
    label: ProjectSectionUnitStatusMap[ProjectSectionUnitStatus.COMPLETED],
  },
  {
    value: ProjectSectionUnitStatus.SELF_PASS,
    label: ProjectSectionUnitStatusMap[ProjectSectionUnitStatus.SELF_PASS],
  },
  {
    value: ProjectSectionUnitStatus.SUPERVISE_PASS,
    label: ProjectSectionUnitStatusMap[ProjectSectionUnitStatus.SUPERVISE_PASS],
  },
  {
    value: ProjectSectionUnitStatus.JG_PASS,
    label: ProjectSectionUnitStatusMap[ProjectSectionUnitStatus.JG_PASS],
  },
  {
    value: ProjectSectionUnitStatus.NOT_PASS,
    label: ProjectSectionUnitStatusMap[ProjectSectionUnitStatus.NOT_PASS],
  },
];
